export default __webpack_public_path__ + "static/media/erp_m_bg.76566e12.png";